// DO NOT EDIT -- generated from fs/services/webber/conversions-migration.proto

export namespace ConversionsMigrationService {

  export const MigrateAjaxSignalsEndpoint = "/grpc/webber.ConversionsMigrationService/MigrateAjaxSignals";
  /** MigrateAjaxSignals adds the Ajax Error Signal to list of default signals for all saved analyses. */
  export function MigrateAjaxSignals(sender: (req: MigrateAjaxSignalsRequest, endpoint: string) => Promise<MigrateAjaxSignalsResponse>, req: MigrateAjaxSignalsRequest): { promise: () => Promise<MigrateAjaxSignalsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, MigrateAjaxSignalsEndpoint),
      endpoint: MigrateAjaxSignalsEndpoint
    };
  }
}

export interface MigrateAjaxSignalsRequest {
  /** @deprecated */
  orgId: string;
  orgIds: string[];
  allOrgs: boolean;
  dryRun: boolean;
}

export interface MigrateAjaxSignalsResponse {
  /** all org IDs for the orgs where the migration was run */
  orgsMigrated: string[];
}
